export default function rochesterReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_ROCHESTER":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
